import { render, staticRenderFns } from "./hotSearch-list.vue?vue&type=template&id=945c06b4&scoped=true&"
import script from "./hotSearch-list.vue?vue&type=script&lang=js&"
export * from "./hotSearch-list.vue?vue&type=script&lang=js&"
import style0 from "./hotSearch-list.vue?vue&type=style&index=0&id=945c06b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945c06b4",
  null
  
)

export default component.exports